<template>
  <div class="navbar-app">
    <nav
      :class="
        lightMood === true
          ? 'navbar navbar-expand-lg navbar-light navbarBackgroundCopy'
          : 'navbar navbar-expand-lg navbar-light navbarBackground'
      "
      style="color: #fff !important;width:100%;"
    >
    <div class="nav-container">
        <img class="navImg" src="../../assets/images/Group_175875.png" alt=""  >
      <div class="profile " >  
        <img class="imgAvatar" src="../../assets/images/Group_133.png" alt=""  >
        <div> 
        <p style="font-size:20px; font-weight:bold;line-height:31px;margin-bottom:0;text-transform:uppercase;" >Helen smith</p>
        <p style="font-size:14px;font-weight:bold; line-height:12px; " >Admin</p>
        </div>
      </div>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          </ul>
          <div class="d-flex">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  @click="changAppMood"
                  :title="
                    lightMood ? 'Switch to dark mood' : 'Switch to light mood'
                  "
                >
                    <img
   :src="moodIcon"
      width="40"
      height="40"
      style="vertical-align: middle;"
    />
                </a>
              </li>
              <!--                            <li class="nav-item">-->
              <!--                                <a class="nav-link" href="#">-->
              <!--                                    <font-awesome-icon :icon="['fas', 'bell']" size="lg"/>-->
              <!--                                </a>-->
              <!--                            </li>-->
              <li class="nav-item">
                <a class="nav-link" href="#" @click="logout">
                <img class="logOutIcon" src="../../assets/images/Group_1758747.png" >
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
       <img   alt="" class="navImg" >
    </nav>
  </div>

  <ConfirmationModal
    v-if="this.isFull || confirmModal"
    :message="confirmMessage"
    confirmBtn="Yes"
    cancleBtn="No"
    @close-modal="confirmModalHandler($event)"
  />
</template>

<script>
import { computed } from "vue";
import ConfirmationModal from "./ConfirmationModal";
import lightIcon from '@/assets/images/Group_175988.png'
import darkIcon  from '@/assets/images/Group_1875875.png'
 
export default {
  name: "navbar-app",
  data() {
    return {
      error: false,
      user: {},
      isFull: false,
      confirmMessage: "",
      confirmModal: false,
      lightMood: null,
      // confirmModal: computed(() => this.$store.state.settings.confirmModal),
      // confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
    };
  },
  mounted() {
    this.user = this.$store.state.auth.user;
    this.lightMood = this.$store.state.settings.isLightMood;
  },
 computed: {
  // This gets the current mood from Vuex store (reactive!)
  isLightMood() {
    return this.$store.state.settings.isLightMood;
  },

  // This computes the correct icon based on store state
  moodIcon() {
    return this.isLightMood ? lightIcon : darkIcon;
  }
},
  components: {
    ConfirmationModal,
  },
  methods: {
    async logout() {
      try {
        this.confirmModal = true;
        this.confirmMessage = "Are you sure you want to logout?";
      } catch (e) {
        this.error = e;
      }
    },

    async confirmModalHandler(event) {
      this.isFull = false;
      this.confirmModal = false;
      if (event) {
        await this.$store.dispatch("logout");
        await this.$router.push({ name: "login-page" });
      }
    },

   async changAppMood(e) {
  const newMood = !this.$store.state.settings.isLightMood;
  
  // Save to localStorage
  localStorage.setItem("lightmood", newMood);
  
  // Dispatch to Vuex store
  this.$store.dispatch("setIsLightMood", newMood);
  
  // Optional: commit directly if it's a mutation
  // this.$store.commit("SET_LIGHT_MOOD", newMood);
},
  },
};
</script>

<style>
.navbar-light .navbar-nav .nav-link {
  color: var(--link-icons-navbar) !important;
}
.navbar-light .navbar-brand {
  color: #fff !important;

}
.nav-container{
 display: flex;
  justify-content: space-between;
  align-items: center;
 width:100%;;
 padding:0 20px
}
.navbar-app {
  display: flex;
  justify-content: space-between;
  align-items: center;
z-index: 99999999999999;
  background-color: #37a6a2;
  width: calc(100vw - 252px);
  margin-left: auto;
  position: fixed;
  height: 81px;
  left: 378px;
  right: 0px;
}
.navImg{
position:absolute;
width:184px;
left:-105px;

}

.imgAvatar{
width:40px;
height:42px;
margin-top: 5px;
}
.profile p {
margin-bottom:2px;
margin-left:10px;
}

.logOutIcon{
    width:40px;
    height:40px;
}

.profile{
margin-left:80px;
display:flex; 
}
@media(max-width:1280px){
  .navbar-app{
    width: calc(100vw - 197px);
        height: 60px;
  }
  .navImg {
    width: 160px;
    left: -91px;
}
}
</style>
